import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {TeamRoster} from './BotComponents';
import QuotationModal from './QuotationModal';

const {FiFileText, FiUsers, FiPrinter} = FiIcons;

export default function FinancePlansSidebar({state, team, bots}) {
  const [tab, setTab] = useState('plans'); // 'plans' | 'roster'
  const [quotePlan, setQuotePlan] = useState(null);

  const plans = (state.plans || []).filter(
    (p) => p.module === 'finance' || p.outputContract === 'financial_model' || p.outputContract === 'task'
  );

  return (
    <aside className="panel chat-module-sidebar">
      <div className="sidebar-tab-header">
        <button
          type="button"
          className={`sidebar-tab-btn ${tab === 'plans' ? 'active' : ''}`}
          onClick={() => setTab('plans')}
        >
          <SafeIcon icon={FiFileText} />
          <span>Saved Plans ({plans.length})</span>
        </button>
        <button
          type="button"
          className={`sidebar-tab-btn ${tab === 'roster' ? 'active' : ''}`}
          onClick={() => setTab('roster')}
        >
          <SafeIcon icon={FiUsers} />
          <span>Team Roster</span>
        </button>
      </div>

      {tab === 'roster' ? (
        <TeamRoster team={team} bots={bots} />
      ) : (
        <div className="finance-plans-list">
          <div className="section-heading">
            <div>
              <span className="eyebrow">Decisions &amp; Forecasts</span>
              <h3>Financial Plans</h3>
            </div>
          </div>

          {plans.length === 0 ? (
            <div className="empty-copy">
              <p>No financial plans saved yet.</p>
              <small>Ask Elena (Finance Lead) to model a scenario, then click “Save as Plan”.</small>
            </div>
          ) : (
            plans.map((plan) => {
              const bot = state.bots?.find((b) => b.id === plan.botId);
              return (
                <article className="finance-plan-card" key={plan.id}>
                  <div className="inline spread">
                    <b>{plan.title}</b>
                    <span className={`status ${plan.status || 'draft'}`}>
                      {plan.status || 'draft'}
                    </span>
                  </div>
                  <div className="plan-meta-row inline spread">
                    <div className="inline" style={{gap: '8px'}}>
                      <span>v{plan.version || 1}</span>
                      {bot && <span>by {bot.name}</span>}
                      {plan.created && <small>{plan.created.slice(0, 10)}</small>}
                    </div>
                    <button
                      type="button"
                      className="button ghost compact"
                      onClick={() => setQuotePlan(plan)}
                      style={{fontSize: '11px', padding: '2px 8px'}}
                      title="Export quotation / print quote"
                    >
                      <SafeIcon icon={FiPrinter} />
                      Export quote
                    </button>
                  </div>
                  {plan.content?.summary && (
                    <p className="plan-summary">{plan.content.summary}</p>
                  )}
                </article>
              );
            })
          )}
        </div>
      )}

      {quotePlan && (
        <QuotationModal plan={quotePlan} onClose={() => setQuotePlan(null)} />
      )}
    </aside>
  );
}
